// Lot 721 — durée écoulée d'un direct, lisible : « < 1 min », « 12 min », « 1 h 05 ».
export const fmtElapsed = (sec) => {
  const m = Math.floor(Math.max(0, sec || 0) / 60);
  if (m < 1) return "< 1 min";
  if (m < 60) return `${m} min`;
  return `${Math.floor(m / 60)} h ${String(m % 60).padStart(2, "0")}`;
};

// Lot 722 — durée d'une rediffusion (secondes) : replay_duration du serveur, sinon début réel → fin du direct ;
// à défaut (anciens directs sans live_started_at) création → fin, retenue seulement si plausible (≤ 6 h).
export const replaySeconds = (l) => {
  const d = Number(l?.replay_duration) || 0;
  if (d > 0) return d;
  const b = l?.ended_at ? Date.parse(l.ended_at) : NaN;
  const span = (startIso) => { const a = startIso ? Date.parse(startIso) : NaN; return Number.isNaN(a) || Number.isNaN(b) || b <= a ? 0 : Math.round((b - a) / 1000); };
  const real = span(l?.live_started_at);
  if (real > 0) return real;
  const approx = span(l?.started_at);
  return approx > 0 && approx <= 6 * 3600 ? approx : 0;
};
